module.exports = __webpack_public_path__ + "e88f018719b91daa499240fc1a2f77d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_150.jpg
// module id = 1698
// module chunks = 5